export const LOCALES = {
    ENGLISH: 'en-US',
    RUSSIAN: 'ru-RU',
};

export const LANGUAGES = [
    { name: 'English', code: LOCALES.ENGLISH, short: "Eng" },
    { name: 'Русский', code: LOCALES.RUSSIAN, short: "Рус" },
];